import { render, staticRenderFns } from "./PackagePricing.vue?vue&type=template&id=6a064c7b&scoped=true&"
import script from "./PackagePricing.vue?vue&type=script&lang=js&"
export * from "./PackagePricing.vue?vue&type=script&lang=js&"
import style0 from "./PackagePricing.vue?vue&type=style&index=0&id=6a064c7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a064c7b",
  null
  
)

export default component.exports